module.exports = __webpack_public_path__ + "8c8905b9e5a727f74debd5a1519544fd.ttf";